import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { HugeiconsIcon } from "@hugeicons/react";
import { Cancel01Icon, Search01Icon } from "@hugeicons/core-free-icons";
import { Button } from "../ui/button";

const SearchBarComponent = (props) => {
  const {
    id,
    fullWidth,
    grow,
    className,
    placeholder,
    initSearch,
    autoFocus,
    value: propValue,
  } = props;

  const [value, setValue] = useState(propValue || "");

  const handleSearchClear = () => {
    setValue("");
    initSearch("");
  };

  // Debounced search with 600ms delay
  useEffect(() => {
    const delaySet = setTimeout(() => {
      if (value !== propValue) {
        initSearch(value);
      }
    }, 600);
    return () => clearTimeout(delaySet);
  }, [value]);

  // Update value when prop changes
  useEffect(() => {
    setValue(propValue || "");
  }, [propValue]);

  return (
    <div
      className={cn(
        "relative",
        fullWidth && "w-full",
        className
      )}
    >
      <button
        type="button"
        onClick={handleSearchClear}
        className="absolute left-2 top-1/2 -translate-y-1/2 px-1 hover:opacity-80 transition-opacity"
      >
        {value ? (
          <HugeiconsIcon icon={Cancel01Icon} className="size-4" />
        ) : (
          <HugeiconsIcon icon={Search01Icon} className="size-4" />
        )}
      </button>
      <Input
        id={id}

        placeholder={placeholder}
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
          if (!e.target.value) {
            handleSearchClear();
          }
        }}
        className={cn("pl-4", className)}
      />
      
    </div>
  );
};

// Default props
SearchBarComponent.defaultProps = {
  id: "dxzc",
  fullWidth: true,
  autoFocus: false,
  grow: "1",
  placeholder: "search",
  value: "",
  initSearch: () => {},
  clearSearch: () => {},
};

// Prop types
SearchBarComponent.propTypes = {
  id: PropTypes.string,
  fullWidth: PropTypes.bool,
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  grow: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  initSearch: PropTypes.func,
  clearSearch: PropTypes.func,
};

export const SearchBar = SearchBarComponent;

export const SlideSearchBar = (props) => {
  const {
    openSearch,
    setOpenSearch,
    EventSearchIcon,
    showCloseIcon = true,
    showSearchIcon = true,
    className,
    ...rest
  } = props;

  return (
    <div className={cn("flex items-center gap-2", className)}> 
      <SearchBarComponent {...rest} />
    </div>
  );
};

SlideSearchBar.propTypes = {
  openSearch: PropTypes.bool,
  setOpenSearch: PropTypes.func,
  EventSearchIcon: PropTypes.node,
  showCloseIcon: PropTypes.bool,
  showSearchIcon: PropTypes.bool,
  className: PropTypes.string,
};
